<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="转让方名字" prop="giveName">
                <Input
                  v-model="query.giveName"
                  clearable
                  placeholder="请输入转让方名字"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="转让方身份证号" prop="giveCardNo">
                <Input
                  v-model="query.giveCardNo"
                  clearable
                  placeholder="请输入转让方身份证号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="受让方名字" prop="getName">
                <Input
                  v-model="query.getName"
                  clearable
                  placeholder="请输入受让方名字"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="受让方身份证号" prop="getCardNo">
                <Input
                  v-model="query.getCardNo"
                  clearable
                  placeholder="请输入受让方身份证号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="不动产单元号" prop="estateUnitno">
                <Input
                  v-model="query.estateUnitno"
                  clearable
                  placeholder="请输入不动产单元号"
                />
              </form-item>
            </i-col>
            <!-- <i-col span="6">
                <form-item label="转移类型" prop="transferType">
                  <Select v-model="query.transferType" clearable>
                    <Option
                      v-for="item in typeList"
                      :key="item.index"
                      :value="item.index"
                      :label="item.type"
                    ></Option>
                  </Select>
                </form-item>
              </i-col> -->
          </row>
        </i-form>
      </div>
      <div class="btn-wrapper box" style="padding-left: 20px">
        <div
          class="btn"
          :class="tapidnex == '1' ? 'active' : ''"
          @click="tabclick(1)"
        >
          全部
        </div>
        <div
          class="btn"
          :class="tapidnex == '2' ? 'active' : ''"
          @click="tabclick(2)"
        >
          已领取
        </div>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-selection-change="handleSelect"
        >
          <template slot-scope="{ row, index }" slot="action">
            <span
              v-if="tapidnex == '1' && row.dealPersonId == null"
              @click.stop="handleClickDetail(row, 'getData')"
              class="action"
              >[领取]</span
            >
            <span
              v-if="tapidnex == '2'"
              @click.stop="handleClickDetail(row, 'file')"
              class="action"
              >[附件]</span
            >
            <span
              v-if="tapidnex == '2'"
              @click.stop="handleClickDetail(row, 'detail')"
              class="action"
              >[查看]</span
            >
            <!-- <span v-if="tapidnex == '2'" @click.stop="handleClickDetail(row, 'upLoad')" class="action">[上传二维码]</span>-->
            <Poptip
              v-if="tapidnex == '2' && isShowPayBtn"
              @on-popper-hide="onPopperHide"
              title="确认已支付?"
            >
              <span class="action">[发送不动产审核]</span>
               <template #content>
                  <div>
                    <Upload
                      v-if="!taxReceiptPhoto"
                      ref="upload"
                      :action="actionuri"
                      :headers="header"
                      :show-upload-list="false"
                      :on-success="handleSuccess"
                      :on-progress="handleProgress"
                      :on-error="handleError"
                      >
                      <Button icon="ios-cloud-upload-outline" :loading="uploadLoading" style="height: 100px;">上传税票照片</Button>
                    </Upload>
                    <img v-if="taxReceiptPhoto" :src="taxReceiptPhoto"  style="object-fit:cover;height:100px;width:100%" alt="图片加载失败" />
                 
                    <Button style="margin-top: 20px;" type="info" long @click="sendRealEstateReview(row, 'state', 'all')">确定</Button>
                  </div>
              </template>
              
            </Poptip>
            <Poptip
              v-if="tapidnex == '2' && isShowAuditBtn"
              confirm
              title="确认审核通过?"
              :disabled="row.checkState == 1 || row.checkState == 2"
              @on-ok="handleClickDetail(row, 'pass')"
            >
              <span class="action">[审核通过]</span>
            </Poptip>
            <span
              v-if="tapidnex == '2' && isShowAuditBtn"
              @click.stop="handleClickDetail(row, 'fail')"
              class="action"
              >[审核驳回]</span
            >
          </template>
          <template slot-scope="{ row, index }" slot="givePayQrUrl">
            <div @click.stop="clickPic(row.givePayQrUrl)" class="action">
              [查看]
            </div>
            <div
              @click.stop="handleClickDetail(row, 'upLoad', 'givePayQrUrl')"
              class="action"
            >
              [上传]
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="givePayState">
            <span>{{ payType[Number(row.givePayState)].type }}</span>
            <Poptip
              confirm
              :title="`确认${Number(row.givePayState) ? '未' : '已'}支付?`"
              placement="left"
              @on-ok="handleClickDetail(row, 'state', 'givePayState')"
            >
              <span class="action">[修改状态]</span>
            </Poptip>
          </template>
          <template slot-scope="{ row, index }" slot="getPayQrUrl">
            <div @click.stop="clickPic(row.getPayQrUrl)" class="action">
              [查看]
            </div>
            <div
              @click.stop="handleClickDetail(row, 'upLoad', 'getPayQrUrl')"
              class="action"
            >
              [上传]
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="getPayState">
            <span>{{ payType[Number(row.getPayState)].type }}</span>
            <Poptip
              confirm
              :title="`确认${Number(row.getPayState) ? '未' : '已'}支付?`"
              placement="left"
              @on-ok="handleClickDetail(row, 'state', 'getPayState')"
            >
              <span class="action">[修改状态]</span>
            </Poptip>
          </template>
          <template slot-scope="{ row, index }" slot="sellPayQrUrl">
            <div @click.stop="clickPic(row.sellPayQrUrl)" class="action">
              [查看]
            </div>
            <div
              @click.stop="handleClickDetail(row, 'upLoad', 'sellPayQrUrl')"
              class="action"
            >
              [上传]
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="sellPayState">
            <span>{{ payType[Number(row.sellPayState)].type }}</span>
            <Poptip
              confirm
              :title="`确认${Number(row.sellPayState) ? '未' : '已'}支付?`"
              placement="left"
              @on-ok="handleClickDetail(row, 'state', 'sellPayState')"
            >
              <span class="action">[修改状态]</span>
            </Poptip>
          </template>
          <template slot-scope="{ row, index }" slot="checkState">
            <span>{{ checkType[Number(row.checkState)].type }}</span>
          </template>
        </i-table>
        <preview-img
          :currentIndex="0"
          :imgArr="showPreview.list"
          v-if="showPreview.show"
          v-on:closePreview="closePreview"
        ></preview-img>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
      <!--上传二维码-->
      <Modal
        v-model="importModal"
        :title="uploadTitle"
        width="660px"
        height="400px"
        :footer-hide="footerHide"
        @on-ok="ok"
      >
        <div class="note box">请上传二维码</div>
        <upload-img
          :imgArr="copyImgArr"
          :imgWidth="100"
          :imgHeight="62.5"
          @saveImg="saveImg"
          @delPic="delPic"
          :imgNumber="imgNumber"
          :fixedNumber="fixedNum"
        >
          <div class="iconfont icon-shangchuan1 img_add"></div>
        </upload-img>
        <template v-if="imgStr == 'getPayQrUrl'">
          <Form ref="formInline" :label-width="60" v-model="uploadGetForm">
            <FormItem prop="ndeedTax" label="契税">
              <Input
                type="number"
                v-model="uploadGetForm.ndeedTax"
                placeholder="请输入契税"
              />
            </FormItem>
            <FormItem prop="stamp" label="印花税">
              <Input
                type="number"
                v-model="uploadGetForm.stamp"
                placeholder="请输入印花税"
              />
            </FormItem>
          </Form>
        </template>
        <template v-else-if="imgStr == 'givePayQrUrl'">
          <Form ref="formInline" :label-width="100" v-model="uploadGiveForm">
            <FormItem prop="incomeTax" label="个人所得税">
              <Input
                type="number"
                v-model="uploadGiveForm.incomeTax"
                placeholder="请输入个人所得税"
              />
            </FormItem>
            <FormItem prop="addvalTax" label="增值税">
              <Input
                type="number"
                v-model="uploadGiveForm.addvalTax"
                placeholder="请输入增值税"
              />
            </FormItem>
            <FormItem prop="stamp" label="印花税">
              <Input
                type="number"
                v-model="uploadGiveForm.stamp"
                placeholder="请输入印花税"
              />
            </FormItem>
          </Form>
        </template>
      </Modal>
      <Modal
        @on-visible-change="onVisibleChange"
        :value="showCheckMsg"
        :title="modalTitle"
        :width="550"
      >
        <div class="estateTitle">
          审核的不动产单元号：
          <row>
            <i-col span="12">
              <div class="estateNO">{{ row.estateUnitno }}</div>
            </i-col>
          </row>
        </div>
        <br />
        <Input
          type="textarea"
          v-model="checkMsg"
          :rows="5"
          placeholder="请输入..."
        />
        <div slot="footer">
          <Button style="margin-right: 10px" @click="showCheckMsg = false"
            >取消</Button
          >
          <Button type="primary" @click="review" :loading="isBtbLoading"
            >确定</Button
          >
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../../components/head";
import PreviewImg from "../../../../components/previewImg";
import uploadImg from "@/components/uploadImg";
import api from "../../../../api/index";
import { order } from "@amcharts/amcharts4/.internal/core/utils/Number";
import { createLogger } from "vuex";
const {
  PromiseList,
  PromiseReceive,
  download1,
  batchCheckLandTransfer,
  saveType,
  deleteCollectionBatch,
  licenseUpload
} = api;
const TYPEMAP = {
  0: {
    checkStatus: "审核未通过"
  },
  1: {
    checkStatus: "审核已通过"
  },
  2: {
    checkStatus: "待审核"
  }
};
export default {
  name: "landTransfer",
  components: {
    pageHead,
    PreviewImg,
    uploadImg
  },

  data() {
    return {
      taxReceiptPhoto:'',
      btnShowList:[],
      uploadTitle: "",
      footerHide: false,
      obj: {},
      uploadGiveForm: {
        incomeTax: 0,
        addvalTax: 0,
        stamp: 0
      },
      uploadGetForm: {
        ndeedTax: 0,
        stamp: 0
      },
      showCheckMsg: false,
      tapidnex: 1,
      copyImgArr: [],
      imgNumber: 1,
      fixedNum: [8, 8],
      importModal: false,
      checkMsg: "",
      checkedId: "",
      modalTitle: "",
      showPreview: {
        show: 0,
        list: []
      }, //预览图片
      checkType: [
        {
          index: 0,
          type: "未审核"
        },
        {
          index: 1,
          type: "已通过"
        },
        {
          index: 2,
          type: "已驳回"
        }
      ],
      payType: [
        {
          index: 0,
          type: "未支付"
        },
        {
          index: 1,
          type: "已支付"
        }
      ],
      typeList: [
        {
          index: 1,
          type: "买卖"
        },
        {
          index: 2,
          type: "离婚析产"
        },
        {
          index: 3,
          type: "赠与"
        },
        {
          index: 4,
          type: "直系亲属"
        },
        {
          index: 5,
          type: "婚内夫妻财产约定"
        },
        {
          index: 6,
          type: "其他"
        }
      ],
      query: {
        giveName: "",
        giveCardNo: "",
        getName: "",
        getCardNo: "",
        estateUnitno: ""
        // transferType:''
      },
      giveName: "",
      giveNameList: [],
      status: "",
      info: {},
      time: "",
      isLoading: false,
      isBtbLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "承诺书",
      btnList: [
        {
          name: "重置",
          type: "reset"
        },
        {
          name: "搜索",
          type: "search"
        }
      ],
      tableHeader: [],
      tableData: [],
      selectedList: [],
      uploadLoading: false,
      header: {
        token: window.sessionStorage.getItem("token")
      },
      actionuri: "",
      row: {},
      imgStr: ""
    };
  },
  computed: {
    isShowAuditBtn() {
      return this.btnShowList.filter(item => item.deptName == '契税合缴审核').length>0
    },
    isShowPayBtn() {
      return this.btnShowList.filter(item => item.deptName == '契税合缴确认支付').length>0
    }
  },
  methods: {
    async ok() {
      let obj = JSON.parse(JSON.stringify(this.obj));
      let uploadForm = {},
        payObj = "";
      if (this.imgStr == "givePayQrUrl") {
        uploadForm = this.uploadGiveForm;
        payObj = "give";
      } else if (this.imgStr == "getPayQrUrl") {
        uploadForm = this.uploadGetForm;
        payObj = "get";
      }
      // uploadForm.map(item => console.log(item));
      let money = Object.values(uploadForm).reduce((pre, next) => {
        return pre + next;
      });
      if (money == 0 && Object.keys(obj).length <= 0)
        this.$Message.error("请上传二维码和至少填写一项费用明细");
      else if (money == 0 && Object.keys(obj).length > 0)
        this.$Message.error("请至少填写一项费用明细");
      else if (money != 0 && Object.keys(obj).length < 0)
        this.$Message.error("请上传二维码");
      else {
        obj = {
          ...obj,
          ...uploadForm,
          payObj: payObj,
          orderNo: this.orderNo,
          payUrl: obj[this.imgStr]
        };
        console.log(obj, 123456);
        let res = await this.$post(saveType, obj);
        if (res.code == 1) {
          this.$Message.success("上传成功");
        } else {
          this.$Message.error("上传失败");
        }
        this.importModal = false;
        this.getLandTransferList();
      }
    },
    tabclick(index) {
      console.log(index);
      this.tapidnex = index;
      this.pageNum = 1;
      this.getLandTransferList();
    },
    saveImg(fileObj) {
      let obj = {
        id: this.row.id
      };
      obj[this.imgStr] = fileObj.path;
      obj.soureType = "web";
      console.log(fileObj);
      this.obj = obj;
    },
    delPic(communityEntity) {
      console.log(communityEntity);
    },
    getSetting() {
      this.btnShowList = []
      this.$get(this.urlobj.getMiniSet).then(res => {
        if (res.isSucceed) {
          this.btnShowList = res.newPrimaryKeys.deptList;
        }else{
          this.$Message.error(res.message);
        }
      });
    },
    handleBtn(type) {
      if (type == "reset") {
        this.pageNum = 1;
        this.$refs.search.resetFields();
        this.getLandTransferList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getLandTransferList();
      }
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.show = 0;
    },
    clickPic(val) {
      if (val) {
        this.showPreview.list = [];
        this.showPreview.list = [{ isHeight: true, path: val }];
        console.log(this.showPreview.list);
        this.showPreview.show = 1;
      } else {
        this.$Message.error("暂无图片");
      }
    },
    handleSelect(selection) {
      this.selectedList = [];
      (this.giveNameList = []), (this.giveName = "");
      console.log(selection);
      selection.forEach(item => {
        this.selectedList.push(item.id);
        this.giveNameList.push(
          item.giveName.replace(/(\d{6})(\d{6})(\w{7})/g, "$1 $2 $3 ")
        );
      });
      console.log(this.selectedList);
    },
    async review() {
      if (!this.checkMsg) {
        return this.$Message.info("请填写审核说明");
      }
      this.isBtbLoading = true;
      try {
        let obj = {
          id: this.row.id,
          checkState: 2,
          soureType: "web",
          rejectReason: this.checkMsg
        };
        let res = await this.$post(saveType, obj);
        if (res.code != 1) {
          this.$Message.error(res.message);
        } else this.$Message.info("操作成功");

        this.showCheckMsg = false;
        this.getLandTransferList();
      } finally {
        this.isBtbLoading = false;
        this.checkedId = "";
      }
    },
    async handleDelete(id) {
      let res = await this.$delete(deleteCollectionBatch, {
        idList: id
      });
      if (res.isSucceed) {
        this.$Message.success("删除成功");
        this.getLandTransferList();
      }
    },
    async handleClickDetail(item, type, str) {
      console.log(item, type, str);
      if (type == "getData") {
        let res = await this.$post(PromiseReceive, {
          id: item.id
        });
        if (res.code != 1) {
          this.$Message.error(res.message);
        }
        this.getLandTransferList();
      } else if (type == "file") {
        this.$router.push({
          name: "commitmentDetail",
          query: { id: item.id }
        });
      } else if (type == "detail") {
        let res = await this.$get(download1("cns"), {
          id: item.id
        });

        if (res.code == 1) {
          let url = res.newPrimaryKeys.attachmentDetail.attachmentUrl;
          window.open(url);
        } else {
          this.$Message.error(res.message);
        }
      } else if (type == "upLoad") {
        this.importModal = true;
        this.imgStr = str;
        this.row = item;
        this.footerHide =
          str == "givePayQrUrl" || str == "getPayQrUrl" ? false : true;
        this.uploadTitle =
          str == "givePayQrUrl" || str == "getPayQrUrl"
            ? "请上传二维码和费用明细"
            : "请上传二维码";
        console.log(this.uploadGetForm, this.uploadGiveForm);
        this.orderNo = item.orderNo;
      } else if (type == "state") {
        if (str == "all") {
          let obj = {
            id: item.id,
            givePayState: 1,
            getPayState: 1,
            sellPayState: 1,
            soureType: "web",
            orderNo: item.orderNo
          };
          let res = await this.$post(saveType, obj);
          if (res.code != 1) {
            this.$Message.error(res.message);
          }
        } else {
          let obj = { id: item.id };
          obj[str] = Number(item[str]) ? 0 : 1;
          obj.soureType = "web";
          obj.orderNo = item.orderNo;

          let res = await this.$post(saveType, obj);
          if (res.code != 1) {
            this.$Message.error(res.message);
          }
        }

        this.getLandTransferList();
      } else {
        if (type == "pass") {
          let obj = {
            id: item.id,
            checkState: 1,
            soureType: "web",
            orderNo: item.orderNo
          };
          let res = await this.$post(saveType, obj);
          if (res.code != 1) {
            this.$Message.error(res.message);
          }
          this.getLandTransferList();
        } else if (type == "fail") {
          this.modalTitle = "审核未通过说明(必填)";
          // this.status = 0;
          this.showCheckMsg = true;
          this.row = item;
        }
        // this.giveName = item.giveName.replace(
        //   /(\d{6})(\d{6})(\w{7})/g,
        //   "$1 $2 $3 "
        // );
        // this.checkedId = item.id;
      }
    },
    onVisibleChange(val) {
      if (!val) {
        this.showCheckMsg = false;
        this.checkMsg = "";
      }
    },

    async sendRealEstateReview(row,state,type){
      
      if (!this.taxReceiptPhoto) {
        this.$Modal.warning({
          title:'提示！',
          content: '税票照片未上传，是否提交？',
          onOk: () => {
            this.handleClickDetail(row, state,type)
          },
        });
      }else{
        let res = await this.$post(licenseUpload, {
          url:this.taxReceiptPhoto,
          orderNo:row.orderNo,
        });
        if (res.isSucceed) {
          this.handleClickDetail(row, state,type)
        }else{
          this.$Message.error(res.message);
        }
        
      }
      
    },

    handleSuccess(response) {
      console.log(response);
      
      this.uploadLoading = false;
      if (response.isSucceed) {
        this.taxReceiptPhoto = response.rows[0].filepath;
        this.$Message.success("上传成功");
      } else {
        this.$Message.error(response.message);
      }
    },
    handleProgress() {
      this.uploadLoading = true;
    },
    handleError() {
      this.uploadLoading = false;
      this.$Message.error("上传失败");
    },
    onPopperHide(){
      this.taxReceiptPhoto = "";
      console.log("关闭");
      
    },
    pageChange(val) {
      this.pageNum = val;
      this.getLandTransferList();
    },
    async getLandTransferList() {
      this.isLoading = true;
      let obj = {};
      if (this.tapidnex == 2) {
        obj.dealPersonId = sessionStorage.uid;
        this.tableHeader = [
          {
            title: "转让方",
            align: "center",
            children: [
              {
                title: "姓名",
                key: "giveName",
                width: 100
              },
              {
                title: "证件号码",
                key: "giveCardno",
                width: 150
              },
              {
                title: "税支付二维码",
                key: "givePayQrUrl",
                slot: "givePayQrUrl",
                width: 90
              },
              {
                title: "支付状态",
                key: "givePayState",
                slot: "givePayState",
                width: 120
              }
            ]
          },
          {
            title: "受让方",
            align: "center",
            children: [
              {
                title: "姓名",
                key: "getName",
                width: 100
              },
              {
                title: "证件号码",
                key: "getCardno",
                width: 150
              },
              {
                title: "税支付二维码",
                key: "getPayQrUrl",
                slot: "getPayQrUrl",
                width: 90
              },
              {
                title: "支付状态",
                key: "getPayState",
                slot: "getPayState",
                width: 120
              }
            ]
          },
          {
            title: "不动产单元号",
            key: "estateUnitno",
            width: 200
          },
          {
            title: "不动产坐落地址",
            key: "estateAddress",
            width: 200
          },
          {
            title: "转移类型",
            key: "transferType",
            width: 120
          },
          {
            title: "出让金",
            align: "center",
            children: [
              {
                title: "二维码",
                key: "sellPayQrUrl",
                slot: "sellPayQrUrl",
                width: 90
              },
              {
                title: "支付状态",
                key: "sellPayState",
                slot: "sellPayState",
                width: 120
              }
            ]
          },
          {
            title: "审核状态",
            width: 120,
            key: "checkState",
            slot: "checkState"
          },
          {
            title: "操作",
            width: 200,
            slot: "action"
          }
        ];
      } else {
        this.tableHeader = [
          {
            title: "转让方姓名",
            key: "giveName"
          },
          {
            title: "转让方证件号码",
            key: "giveCardno"
          },
          {
            title: "受让方姓名",
            key: "getName"
          },
          {
            title: "受让方证件号码",
            key: "getCardno"
          },
          {
            title: "不动产单元号",
            key: "estateUnitno"
          },
          {
            title: "不动产坐落地址",
            key: "estateAddress"
          },
          {
            title: "转移类型",
            key: "transferType"
          },
          {
            title: "领取人",
            key: "dealPerson"
          },
          {
            title: "操作",
            width: 100,
            slot: "action"
          }
        ];
      }
      try {
        let res = await this.$get(PromiseList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          soureType: "web",
          ...this.query,
          ...obj
        });
        console.log(this.query);
        this.tableData = res.rows;

        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    }
  },

  created() {
    this.getLandTransferList();
    this.getSetting();
    console.log(this.$route);
    this.actionuri = this.urlobj.uploadFile;
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}
.time {
  width: 100%;
}
.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .success {
    color: #ff7b44;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}

.statistics {
  padding: 10px 0;
  text-align: right;
}

.estateTitle {
  color: #ff7b44;
  font-weight: bold;
}

.estateNO {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}

.btn-wrapper {
  margin: 20px 0;
  .btn {
    height: 30px;
    line-height: 30px;
    /*width: 50px;*/
    padding: 0 10px;
    text-align: center;
    background: #fff;
    color: #999;
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .active {
    background: #ff7b44;
    color: #fff;
  }
}
</style>
<style>
.ivu-table-wrapper{
  overflow: initial !important;
}
</style>